import "bootstrap/dist/css/bootstrap.css";
import "./App.css";
import Auth from "./Auth";

import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import React from "react";
import Dashboards from "./Pages/PagesWrapper";
import FormPage from "./Pages/Login";
import { ProtectedRoute } from "./protected.route";

function App() {
  return (
    <Router>
      <Switch>
        {Auth.isAuthenticated() ? (
          <Route path={["/login", "/"]} exact>
            <Redirect to="/koinot/create" />
          </Route>
        ) : (
          <Route path={["/", "/login"]} exact component={FormPage} />
        )}

        <ProtectedRoute exact path="/koinot/:menu" component={Dashboards} />
        <Route path="*" component={() => "404 NOT FOUND"} />
      </Switch>
    </Router>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js